import axios from "axios";
import { PRICElIST_BASE_URL, STORE_BASE_URL } from "../BaseURL";
import getHeaders from "../../constants/headers";

export const postGarmentCategoryV3 = (storeId, data) => {
    return axios({
      method: 'post',
      url:
        PRICElIST_BASE_URL +
        '/api/secure/v3/store/' +
        storeId +
        '/garment-category',
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };
  
  export const getStoreGarmentRemarks = (brandId, storeId) => {
    return axios({
      method: 'get',
      url:
        PRICElIST_BASE_URL +
        '/api/secure/v1/brand/' +
        brandId +
        '/garment-remark/store/' + storeId,
      headers: getHeaders(),
    });
  };

  export const getStoreGarmentRemarksPriority = (brandId) => {
    return axios({
      method: "get",
      url:
        PRICElIST_BASE_URL +
        "/api/secure/v1/brand/" +
        brandId +
        "/remark-priority/",
      headers: getHeaders(),
    });
  };

  export const getStoreGarmentCategoryServicesByPriceId = (
    storeId,
    storeCustomerId,
    garmentCategoryId,
    priceId,
  ) => {
    return axios({
      method: 'get',
      url:
        STORE_BASE_URL +
        '/store/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        storeCustomerId +
        '/price/' +
        priceId +
        '/garment-category/' +
        garmentCategoryId +
        '/service/',
      headers: getHeaders(),
    });
  };

  export const getGarmentPack = (brandId) => {
    return axios({
      method: 'get',
      url:
        PRICElIST_BASE_URL +
        '/api/secure/v2/brand/' +
        brandId +
        '/garment-pack',
      headers: getHeaders(),
    });
  };